import getIn from 'transmute/getIn';
export const getChatflowConnectionStatuses = getIn(['chatflowConnectionStatus']);